module.exports = __webpack_public_path__ + "media/dashboard/assets/images/hero/hero-forgotpassword-09a70b6c35fd1058f7f5eb633aad2cfe.svg";